exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#ny2020[data-v-92abf654] {\n    height: 66px;\n}\n@media (max-width: 992px) {\n#ny2020[data-v-92abf654] {\n        display: none;\n}\n}\n", ""]);

// exports
